import { render } from "./Main_content_manage.vue?vue&type=template&id=ba0ed540&scoped=true"
import script from "./Main_content_manage.vue?vue&type=script&lang=js"
export * from "./Main_content_manage.vue?vue&type=script&lang=js"

import "./Main_content_manage.vue?vue&type=style&index=0&id=ba0ed540&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba0ed540"]])

export default __exports__